<template>
  <div>
    <div style="margin: 5px;">
      <el-select v-model="infoType" placeholder="请选择" @change="getList">
        <el-option label="全部消息" value="0"></el-option>
        <el-option label="未读消息" value="1"></el-option>
      </el-select>
    </div>
    <div class="feedBack-list empty-state" v-if="emptyState">
      <!-- <img src="./img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
      <span style="margin-bottom: 20px;">暂无数据</span> -->
    </div>
    
    <div class="feedBack-list" v-else style="height:475px;overflow:auto;">
      <div v-for="(item, index) in feedBackList" :key="index">
        <div class="feedBack-time">{{ item[0].feedBackTimeType }}</div>
        <div
          v-for="(it, i) in item"
          :key="i"
          :class="it.isConfirm ? 'is-confirm' : ''"
        >
          <div
            class="feedBack-item"
            @click="clickHandler(it)"
            v-if="it.isInRelation"
          >
            <div class="reason">原因：{{ it.passFailReason }}</div>
            <div class="detail">
              <i class="el-icon-s-custom"></i>
              {{ it.followupPatientName }}·{{ it.spotCheckTime }}·来自{{
                it.followUpTaskName
              }}<br />
            </div>
            <div class="handle-result">
              质控结果：{{ it.secondSpotCheckState == 1 ? '合格' : '不合格' }}·{{
                it.handleResultName
              }}【{{ it.firstSpotCheckState }}<span>{{it.spotCheckRemarks}}</span>】
            </div>
          </div>
          <div class="feedBack-item-outtime" v-else>
            <div style="padding: 20px">
              <i class="el-icon-warning-outline"></i> 任务过期，无需质控
            </div>
            <div class="outtime-delete" @click="deleteHandler(it)">删除</div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- <div> <el-divider style="color: #DBDBDB ;"></el-divider></div> -->
    <div style="text-align: center; color: #dbdbdb; margin: 6px">
      仅展示6个月内通知
    </div>
  </div>
</template>

<script>
import {
  RestFeedbackOutControllerGetPassFailFeedBackList, //质控反馈列表
  RestFeedbackOutControllerIsInRelationTask,
  RestFeedbackOutControllerDeleteRemindByIds,
  RestFeedbackOutControllerConfirmFeedbackById,
  RestFeedbackOutControllerGetFollowupTaskPatientInfo,
} from '@src/assets/js/api.js'

export default {
  name: 'hr-quality-control',
  // props: ['QCList'],
  computed: {},
  data() {
    return {
      userId: sessionStorage.getItem('userid'),
      feedBackList: [],
      passFailedCount: '0',
      infoType: '0',
      emptyState:false,
    }
  },
  components: {},
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.feedBackList = []
      this.emptyState = false
      this.getPassFailFeedBackListAsync().then((res) => {
        let filterData = res.retValue.filter((item) => {
          return item.isConfirm == false
        })
        this.passFailedCount = filterData.length
        let feedBackTimeTypeArr = []
        let arr = res.retValue.map((item) => {
          item.handleResultName = item.handleResult
            ? this.getHandleresult(item.handleResult)
            : ''
          item.isInRelation = true
          item.feedBackTimeType = item.feedBackTime.split(' ')[0]
          feedBackTimeTypeArr.push(item.feedBackTimeType)
          return item
        })
        // 去重
        let newArr = feedBackTimeTypeArr.filter(function (value, index, self) {
          return self.indexOf(value) === index
        })
        newArr.forEach((newArrItem, index) => {
          newArrItem = arr.filter((arrItem) => {
            return newArrItem == arrItem.feedBackTimeType
          })
          this.feedBackList.push(newArrItem)
        })

        this.feedBackList.length==0?this.emptyState = true:this.emptyState = false;
      })
    },
    clickHandler(param) {
      this.isInRelationTaskAsync(param.id).then((res) => {
        this.feedBackList = this.feedBackList.map((_item) => {
          _item.map((item) => {
            if (item.id == param.id) {
              item.isInRelation = res.retValue
              if (res.retValue) {
                this.gotoPage(param)
              }
            }
            return item
          })
          return _item
        })
      })
    },
    gotoPage(param) {
      this.getFollowupTaskPatientInfoAsnyc({
        userId: this.userId,
        followupTaskId: param.followUpTaskId,
      }).then((res) => {
        if (res.status == 0) {
          localStorage.setItem('taskId', param.followUpTaskId)
          this.confirmFeedbackByIdAsync(param.id).then((res) => {
            if (res.status == 0) {
              this.$router.push({
                path: '/internalQualityControl',
                query: {
                  adNo:param.admitNo
                }
              })
              this.$emit('closeDialog')
            }
          })
        } else {
          this.$message.error('暂无需要抽查任务')
        }
      })
    },
    deleteHandler(param) {
      let ids = []
      ids.push(param.id)
      this.deleteRemindByIdsAsync(ids).then((res) => {
        if (res.status == 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    // ========
    async getPassFailFeedBackListAsync() {
      let request = new RestFeedbackOutControllerGetPassFailFeedBackList()
      request.p_userId = this.userId
      request.p_isConfirm = this.infoType*1==1?0:null;   //全部消息：0，未读消息1 是否已读：0否，1是
      await request.send()
      return request.result
    },
    async isInRelationTaskAsync(pid) {
      let request = new RestFeedbackOutControllerIsInRelationTask()
      request.p_id = pid
      await request.send()
      return request.result
    },
    async deleteRemindByIdsAsync(pid) {
      let request = new RestFeedbackOutControllerDeleteRemindByIds()
      request.p_id = pid
      await request.send()
      return request.result
    },
    async confirmFeedbackByIdAsync(pid) {
      let request = new RestFeedbackOutControllerConfirmFeedbackById()
      request.p_id = pid
      await request.send()
      return request.result
    },

    async getFollowupTaskPatientInfoAsnyc(p) {
      let request = new RestFeedbackOutControllerGetFollowupTaskPatientInfo()
      request.p_followupTaskId = p.followupTaskId
      request.p_userId = p.userId
      await request.send()
      return request.result
    },
  },
}
</script>
<style lang="scss" scoped>
.is-confirm {
  color: #ccc;
  .feedBack-item .reason {
    color: #ccc;
  }
}
.feedBack-time {
  text-align: center;
  margin: 10px;
}
.feedBack-item {
  font-size: 15px;
  // border: 1px solid;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 1px 1px 3px 1px #ccc;
  cursor: pointer;
  margin-bottom: 13px;
  .reason {
    color: #000;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .detail {
    line-height: 26px;
  }
  .handle-result {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    padding-left: 18px;
  }
}
.feedBack-item:hover {
  background: #f4f4f4;
}
.feedBack-item-outtime {
  height: 100px;
  font-size: 15px;
  border-radius: 6px;
  box-shadow: 1px 1px 2px 1px #ccc;
  display: grid;
  grid-template-rows: 60% 40%;
  text-align: center;
  margin-bottom: 13px;
  .outtime-delete {
    padding: 10px;
    border-top: 1px solid #ccc;
    cursor: pointer;
  }
  .outtime-delete:hover {
    background: #f4f4f4;
  }

  .empty-state {
    display: flex;
    padding-top: 15%;
    align-items: center;
    flex-direction: column;
  }
}
</style>
<style lang="scss">
.top-feedback-dialog {
  .el-dialog__body {
    padding: 10px 20px 0 20px;
    .el-divider__text {
      color: #ccc;
    }
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.02);
  }

  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px #fff;
    border-radius: 10px;
    background: #ededed;
  }
}
</style>
